module.exports = "/assets/landing-cf/instagram/insta-feed-3.jpg?lz0KWdm";